import request from '@/utils/request'

// 首页--列表数据
export function findDeviceList(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      data: params
    })
  }
}
// 详情页--详情
export function findDeviceInfo(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      data: params
    })
  }
}
// 详情页--设置
export function sendPGTData(params) {
  return request({
    url: '/v3/device/mqtt/sendPGTData',
    method: 'post',
    data: params
  })
}
